const styles = (theme) => ({
  accordionItem: {
    border: 'none',
    boxShadow: 'none',
    '&:before': {
      display: 'none',
    },
    '&.Mui-expanded': {
      marginTop: 0,
      marginBottom: 0,
    },
  },
  accordionSummary: {
    textTransform: 'uppercase',
    color: theme.color.grey_8A,
    padding: theme.overrides.MuiExpansionPanel.padding,
    minHeight: 40,
    '&.Mui-expanded': {
      minHeight: 40,
    },
  },
  summaryContent: {
    marginTop: 10,
    marginBottom: 10,
    '&.Mui-expanded': {
      marginTop: 10,
      marginBottom: 10,
    },
  },
  unpaddedSummaryContent: {
    marginTop: 0,
    marginBottom: 0,
    '&.Mui-expanded': {
      marginTop: 0,
      marginBottom: 0,
    },
  },
  accordionContent: {
    color: theme.color.black_80,
    paddingBottom: 0,
    paddingTop: 0,
  },
  dropdownIcon: {
    fill: theme.color.grey_8A,
  },
});

export default styles;
